type Position = 'absolute' | 'relative' | undefined;
type Justify = 'center' | 'initial' | 'inherit' | 'unset' | 'flex-start' | 'flex-end';
type AlignItems = 'center' | 'initial' | 'inherit' | 'unset' | 'flex-start' | 'flex-end';
type Direction = 'row' | 'column' | 'row-reverse' | 'column-reverse' | undefined;
type FontStyle = 'normal' | 'italic';
type TextAlign = 'center' | 'auto' | 'left' | 'right' | undefined;
type FlexAlignType = 'initial' | 'inherit' | 'unset' | 'row' | 'row-reverse' | 'column' | 'column-reverse' | undefined;
type ResizeMode = 'cover' | 'contain' | 'stretch' | 'center' | 'repeat' | undefined;
type FlexWrap = 'initial' | 'inherit' | 'unset' | 'wrap' | 'nowrap' | 'wrap-reverse' | undefined;

export const CONSTANTS = {
    ALIGN_ITEMS: {
        CENTER: 'center' as AlignItems,
        START: 'flex-start' as AlignItems,
        END: 'flex-end' as AlignItems,
    },
    BOX_SHADOW: {
        CONTAINER: '#00000026 0 0 15px',
        SUMMARY_BUTTON: '#00000012 0 10px 14px',
        TABLE: '#00000016 0 3px 6px',
        TOP_NAV_BAR: 'rgba(0, 0, 0, 0.05)0 10px 14px',
        BUTTON: '#BFC6D036 0 0 3px',
        PANEL: 'rgba(0, 0, 0, 0.04) 5px 10px 12px',
        LOGIN_BUTTONS: 'rgba(70, 128, 255, 0.32) 0px 7px 20px',
        TEXT_INPUT: '0 0 0 0.2rem rgba(0,123,255,.25)',
        NEED_HELP_BUTTON: 'rgba(0, 0, 0, 0.22) 8px 4px 17px 0px',
    },
    COLORS: {
        BORDER_GREY: '#E4E8F3',
        DROP_DOWN_GREY: '#DFE2EB',
        INPUT_BORDER_GREY: '#D0D7DD',
        DARKEST_GREY: '#192340',
        DARK_GREY: '#595A62',
        THEME_GREY: '#8B93A7',
        TABLE_HEAD_GREY: '#F8F8F9',
        TABLE_CELL_GREY: '#676972',
        THEME_BLUE: '#4680FF',
        THEME_BLUE_DISABLED: '#A4C2FF',
        PAGE_BACKGROUND: '#F9F9F9',
        DISABLED: '#BFC6D0',
        WHITE: '#FFFFFF',
        SEARCH_GREY: '#98999F',
        SLIDER_GREY: '#CCCCCC',
        LEADERBOARD_TEXT: '#3d3f4a',
        LOGIN_BORDER: '#F1F5F7',
        INPUT_LABEL_GREY: '#888888',
        BUTTON_OUTLINE_GREY: '#95989A',
        BUTTON_TEXT_GREY: '#8B93A7',
        BUTTON_BACKGROUND_GREY: '#EAEAEA',
        THEME_ORANGE: '#FFA129',
        THEME_RED: 'red',
        SUB_TITLE_TEXT_GREY: '#8B93A7',
        DELTA_BACKGROUND: '#FFF5CACC',
        DELTA_TEXT: '#FFD100',
        TRANSPARENT: 'transparent',
        TEXT_INPUT_BORDER: '#ced4da',
        TEXT_INPUT_BORDER_FOCUS: '#80bdff',
        GRAPH_GREY: '#f5f5f5',
    },
    DISPLAY: {
        INLINE_FLEX: 'inline-flex',
        FLEX: 'flex',
        NONE: 'none',
    },
    FLEX_GROW: {
        ONE: 1,
        ZERO: 0
    },
    POSITION: {
        ABSOLUTE: 'absolute' as Position,
        RELATIVE: 'relative' as Position
    },
    FLEX_ALIGN: {
        CENTER: 'center' as Justify,
        STRETCH: 'stretch' as FlexAlignType,
        START: 'flex-start' as FlexAlignType,
        END: 'flex-end' as FlexAlignType
    },
    FLEX_JUSTIFY: {
        CENTER: 'center' as Justify,
        END: 'flex-end' as Justify,
        START: 'flex-start' as Justify,
        SPACE_BETWEEN: 'space-between' as Justify,
        SPACE_AROUND: 'space-around' as Justify
    },
    FLEX_DIRECTION: {
        ROW: 'row' as Direction,
        COLUMN: 'column' as Direction
    },
    FLEX_WRAP: {
        WRAP: 'wrap' as FlexWrap
    },
    FONT_FAMILY: '"Nunito Sans", sans-serif',
    FONT_STYLE: {
        NORMAL: 'normal' as FontStyle,
        ITALIC: 'italic' as FontStyle
    },
    FONT_WEIGHT: {
        LIGHT: '300',
        NORMAL: '400',
        SEMI_BOLD: '600',
        BOLD: '700'
    },
    FONT_SIZE: {
        SMALL: 12,
        DEFAULT: 14,
        MEDIUM: 16,
        LARGE: 18,
        X_LARGE: 22,
        XX_LARGE: 24
    },
    TEXT_ALIGN: {
        AUTO: 'auto' as TextAlign,
        LEFT: 'left' as TextAlign,
        CENTER: 'center' as TextAlign,
        RIGHT: 'right' as TextAlign,
        JUSTIFY: 'justify' as TextAlign
    },
    TEXT_DECORATION: {
        NONE: 'none',
        UNDERLINE: 'underline',
        LINE_THROUGH: 'line-through',
        UNDERLINE_LINE_THROUGH: 'underline line-through'
    },
    IMAGE: {
        resizeMode: {
            COVER: 'cover' as ResizeMode,
            CONTAIN: 'contain' as ResizeMode,
            STRETCH: 'stretch' as ResizeMode,
            REPEAT: 'repeat' as ResizeMode,
            CENTER: 'center' as ResizeMode
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/UIConstants.ts